import * as actionTypes from './actionTypes';
import axios from '../../axios/Backend';
import * as fileReq from '../../axios/requests/filesReq'

const delayNow = ms => new Promise(resolve => setTimeout(resolve, ms))

export const fetchChatStart = () => {
    return (
        {
            type: actionTypes.FETCH_CHATS_START
        }
    );
};

export const fetchChatSuccess = (chats) => {
    return (
        {
            type: actionTypes.FETCH_CHATS_SUCCESS,
            chats: chats
        }
    );
};

export const fetchChatFail = (errorChat) => {
    return (
        {
            type: actionTypes.FETCH_CHATS_FAIL,
            errorChat: errorChat
        }
    );
};

export const fetchChat = (whatChats = {}) => {//{ completed: false, isPublic: false }
    return async dispatch => {
        try {
            whatChats.completed = whatChats.completed || false
            whatChats.isPublic = whatChats.isPublic || false
            dispatch(fetchChatStart());
            const resData = await axios.post('/chats/getchats', whatChats);
            const data = resData.data;
            dispatch(fetchChatSuccess(data));
        } catch (e) {
            dispatch(fetchChatFail(e));
            console.log(e);
        }
    };
};

export const fetchMsgStart = () => {
    return (
        {
            type: actionTypes.FETCH_MSGS_START
        }
    );
};

export const fetchMsgSuccess = (msgs, clientName, channel, newLoadedMsgCount, areMoreMsgToLoad, newLoadedMsgFromPagingCount, chatSelectedChannelId, reloadChat) => {
    return (
        {
            type: actionTypes.FETCH_MSGS_SUCCESS,
            msgs: msgs,
            clientName: clientName,
            channel: channel,
            newLoadedMsgCount: newLoadedMsgCount,
            areMoreMsgToLoad: areMoreMsgToLoad,
            newLoadedMsgFromPagingCount: newLoadedMsgFromPagingCount,
            chatSelectedChannelId: chatSelectedChannelId,
            reloadChat: reloadChat
        }
    );
};

export const fetchMsgFail = (errorMsg) => {
    return (
        {
            type: actionTypes.FETCH_MSGS_FAIL,
            errorMsg: errorMsg
        }
    );
};

export const fetchChatUpdatedCrmDataSuccess = () => {
    return (
        {
            type: actionTypes.FETCH_CHAT_UPDATE_CRM_DATA_SUCCESS
        }
    );
};

//fetchChatUpdatedCrmData
export const fetchChatUpdatedCrmData = (listOfChats) => {
    return async dispatch => {
        try {
            dispatch(fetchChatStart());
            for (let conv of listOfChats) {
                if (conv.isChatMultiSelected) {
                    await axios.put('/fetchChatUpdatedCrmData', { clientName: conv.clientName, msgType: conv.msgType });
                    await delayNow(125)
                }
            }

            dispatch(fetchChatUpdatedCrmDataSuccess());
        } catch (e) {
            dispatch(fetchChatFail(e));
            console.log(e);
        }
    };
};

export const fetchMsg = (clientName, channel, toloadMsgCount, startIndex, loadedMsgFromPagingCount, chatSelectedChannelId, reloadChat, msgId, startTime, finishTime) => {
    return async dispatch => {
        try {

            if (startIndex === 0) {
                dispatch(fetchMsgStart());
            }
            const dataTosend = {
                clientName: clientName,
                channel: channel,
                skip: startIndex,
                limit: toloadMsgCount,
                msgId,
                startTime,
                finishTime
            };
            const resData = await axios.post('/msgs/getmsgs', dataTosend);//here
            const data = resData.data;
            const newLoadedMsgCount = startIndex + data.length
            const newLoadedMsgFromPagingCount = loadedMsgFromPagingCount + data.length
            const areMoreMsgToLoad = newLoadedMsgCount % toloadMsgCount === 0 && data.length > 0
            dispatch(fetchMsgSuccess(data, clientName, channel, newLoadedMsgCount, areMoreMsgToLoad, newLoadedMsgFromPagingCount, chatSelectedChannelId, reloadChat));
        } catch (e) {
            fetchMsgFail(e);
        }
    };
};

export const sendMsgStart = () => {
    return (
        {
            type: actionTypes.SEND_MSGS_START
        }
    );
};

export const sendMsgSuccess = (msg) => {
    return (
        {
            type: actionTypes.SEND_MSGS_SUCCESS,
            msg: msg
        }
    );
};

export const sendMsgFail = (errorSendMsg) => {
    return (
        {
            type: actionTypes.SEND_MSGS_FAIL,
            errorSendMsg: errorSendMsg
        }
    );
};

// const mediaArr = media?.length > 0 ? media : []
// dispatch(sendMsgStart());
// let mediaArr = [];
// let fileRes = null;
// let filedata = null;
// if (media) {
//     for (let i = 0; i < media.length; i++) {
//         filedata = new FormData();
//         filedata.append('file', media[i]);
//         try {
//             fileRes = await axios.post('/files', filedata);
//             mediaArr.push(fileRes.data._id);
//         } catch (e) {
//             fileRes = null;
//         };
//     }
// }

// let responseData
// console.log(`test ${dateAndTimeForSendTemplate}`);
export const sendMsg = (clientName, channel, msg, media, opt = null, cb, dateAndTimeForSendTemplate) => {//todo file manager
    return async dispatch => {
        try {
            dispatch(sendMsgStart());
            const mediaArr = []
            if (media?.length > 0) {//fileReq
                for (const mediaObj of media) {
                    if (!mediaObj._id) {// not already added to the server so their is no _id available - add before send
                        const uploadedFile = await fileReq.uploadFile(mediaObj, false)
                        mediaArr.push(uploadedFile._id)
                    }
                    else { // in the server just add the _id
                        mediaArr.push(mediaObj._id)
                    }
                }

            }

            let dataTosend = null
            let response
            if (mediaArr[0]) {
                if (channel === 'instagram' || channel === 'messenger') {
                    if (msg && msg !== '') {
                        dataTosend = {
                            To: clientName,
                            Body: msg,
                            channel: channel,
                            opt: opt
                        }
                        response = await axios.post('/channels/sendmsg', dataTosend);//here
                    }
                    for (let mediaId of mediaArr) {
                        dataTosend = {
                            To: clientName,
                            Body: '',
                            channel: channel,
                            media: [mediaId],
                            opt: opt,
                            dateAndTimeForSendTemplate: dateAndTimeForSendTemplate
                        }
                        response = await axios.post('/channels/sendmsg', dataTosend);//here
                    }

                }
                else {
                    dataTosend = {
                        To: clientName,
                        Body: msg,
                        channel: channel,
                        media: mediaArr,
                        opt: opt,
                        dateAndTimeForSendTemplate: dateAndTimeForSendTemplate
                    }
                    response = await axios.post('/channels/sendmsg', dataTosend);//here
                }
            }
            else {
                dataTosend = {
                    To: clientName,
                    Body: msg,
                    channel: channel,
                    opt: opt,
                    dateAndTimeForSendTemplate: dateAndTimeForSendTemplate
                }
                response = await axios.post('/channels/sendmsg', dataTosend);//here
            }

            if (channel === 'messenger' && opt.selectedMsgAction === 'FORWARD_TO_OTHER_CHANNEL' && cb) {
                cb('message sent successfully', response.status)
            }

        } catch (e) {
            console.log(e);
            dispatch(sendMsgFail(e));// TODO - handle sending errors 
            if (e.response?.data?.message && cb) {
                // if (channel === 'messenger' && opt.selectedMsgAction === 'FORWARD_TO_OTHER_CHANNEL' && cb) {
                cb(e.response.data.message, e.response.status || 400)
                // }
            }
        }
    };
};

export const logoutMsgs = () => {
    return {
        type: actionTypes.LOGOUT_SUCCESS
    }
}

// export const chatSelected = (senderName, chatSelectedChannel) => {
//     return {
//         type: actionTypes.CHAT_SELECTED,
//         chatSelectedSenderName: senderName,
//         chatSelectedChannel: chatSelectedChannel
//     }
// }

export const chatUnSelected = () => {
    return {
        type: actionTypes.CHAT_UNSELECT,
    }
}

export const newMsgRecived = (msg) => {
    return {
        type: actionTypes.NEW_MSG_RECIVED,
        msg: msg
    }
}

export const updateConversation = (conversation, chatTypeSelected, agentName, isAgentOnConvGroups) => {
    return {
        type: actionTypes.UPDATE_CONVERSATION,
        conversation: conversation,
        chatTypeSelected: chatTypeSelected,
        agentName: agentName,
        isAgentOnConvGroups: isAgentOnConvGroups
    }
}

export const newConversation = (conversation) => {
    return {
        type: actionTypes.NEW_CONVERSATION,
        conversation: conversation
    }
}

export const updateMsgRecived = (msg) => {
    return {
        type: actionTypes.UPDATE_MSG_RECIVED,
        msg: msg.msg,
        chat: msg.chat
    }
}

export const deleteMsgRecived = (msg, chat) => {
    return {
        type: actionTypes.DELETE_MSG_RECIVED,
        msg: msg,
        chat: chat
    }
}

export const clearMsgs = () => {
    return {
        type: actionTypes.CLEAR_MSGS
    }
}

export const multiSelectUnselectChat = (clientName, msgType) => {
    return {
        type: actionTypes.MULTI_SELECT_UNSELECT_CHAT,
        clientName: clientName,
        msgType: msgType
    }
}

export const selectMsg = (selectedMsg, selectedMsgAction, opt) => {
    return {
        type: actionTypes.SELECT_MSG,
        selectedMsg: selectedMsg,
        selectedMsgAction: selectedMsgAction,
        opt
    }
}

export const multiSelectUnselectAllChat = (selectType) => {
    return {
        type: actionTypes.MULTI_SELECT_UNSELECT_ALL_CHAT,
        selectType: selectType
    }
}

export const updateChat = (clientName, channel, opt, cb) => {//todo
    return async dispatch => {
        try {
            const objectSend = {
                clientName: clientName,
                completed: opt.completed,
                isPublic: opt.isPublic,
                newAgent: opt.newAgent,
                isForwarding: opt.isForwarding,
                notSeenCount: opt.notSeenCount,
                channel: channel,
                removeAgentFromChat: opt.removeAgentFromChat

            };
            await axios.put('/chats', objectSend);//here
            if (cb) {
                cb()
            }
        } catch (e) {
            console.log(e);
        }
    }
}

export const deleteChat = (clientName, channel) => {
    return async dispatch => {
        try {
            await axios.delete(`/chats/${clientName.replace('+', 'plus')}/${channel}`);//here'/chats/' + clientName.replace('+','') + '/' + channel
        } catch (e) {
            console.log(e);
        }
    }
}


export const deleteChatRecived = (data, chatTypeSelected) => {
    return {
        type: actionTypes.DELETE_CHAT_RECIVED,
        chat: data.chat,
        isCompletelyDelete: data.isCompletelyDelete,
        chatTypeSelected: chatTypeSelected
    }
}

export const deleteManyChats = (filters) => {
    return {
        type: actionTypes.DELETE_MANY_CHATS,
        filters: filters
    }
}

export const setCategory = (completed, isPublic) => {
    return {
        type: actionTypes.SET_CATEGORY,
        completed: completed,
        isPublic: isPublic
    }
}

export const initCategoryMsgUnSeenStatusSuccess = (data) => {
    return {
        type: actionTypes.INIT_CATEGORY_MSG_UNSEEN_STATUS,
        CategoryMsgUnSeenObj: data
    };
};

export const initCategoryMsgUnSeenStatus = () => {
    return async dispatch => {
        try {
            let res = await axios.get('/chats/getallcategoryunreadcount')
            dispatch(initCategoryMsgUnSeenStatusSuccess(res.data))
        } catch (e) {
            console.log('Dialer:fetchCalls:Error=' + e)
        }

    }
};

export const updateCategoryMsgUnSeenStatus = (categoryUnSeenStatusUpdateObj) => {
    return {
        type: actionTypes.UPDATE_CATEGORY_MSG_UNSEEN_STATUS,
        categoryUnSeenStatusUpdateObj: categoryUnSeenStatusUpdateObj
    }
}

// CONTACTS

export const insertChatContact = (contact) => {
    return {
        type: actionTypes.INSERT_CHAT_CONTACT,
        contact
    }
}

export const updateChatContact = (contact) => {
    return {
        type: actionTypes.UPDATE_CHAT_CONTACT,
        contact
    }
}

export const deleteChatContact = (contact) => {
    return {
        type: actionTypes.DELETE_CHAT_CONTACT,
        contact
    }
}

export const sendMsgWithoutSavingStart = () => ({
    type: actionTypes.SEND_MSG_WITHOUT_SAVING_START,
});

export const sendMsgWithoutSavingSuccess = (msgId) => ({
    type: actionTypes.SEND_MSG_WITHOUT_SAVING_SUCCESS,
    msgId: msgId,
});

export const sendMsgWithoutSavingFail = (errorSendMsg) => ({
    type: actionTypes.SEND_MSG_WITHOUT_SAVING_FAIL,
    errorSendMsg: errorSendMsg,
});

export const sendMsgWithoutSavingToMongo = (clientName, msgType, msgBody, media = [], opt = {}, cb) => {
    return async (dispatch) => {
        try {
            dispatch(sendMsgWithoutSavingStart());
            const mediaArray = Array.isArray(media) ? media : [];
            const mediaIds = [];
            if (mediaArray.length > 0) {
                for (const mediaObj of mediaArray) {
                    if (!mediaObj._id) {
                        const uploadedFile = await fileReq.uploadFile(mediaObj, false);
                        mediaIds.push(uploadedFile._id);
                    } else {
                        mediaIds.push(mediaObj._id);
                    }
                }
            }
            const dataToSend = {
                mediaIds: mediaIds,
                msgBody: msgBody,
                clientName: clientName,
                msgType: msgType,
                ...opt,
            };

            const response = await axios.post('/api/v2/msg/sendMsgWithoutSavingToDB', dataToSend);
            if (response.data?.data?.msgId) {
                dispatch(sendMsgWithoutSavingSuccess(response.data.data.msgId));
                if (cb) cb('Message sent successfully', response.status);
            }
        } catch (error) {
            dispatch(sendMsgWithoutSavingFail(error));
            if (error.response?.data?.message && cb) {
                cb(error.response.data.message, error.response.status || 400);
            }
        }
    };
};